var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract-details container container_30" },
    [
      _vm.isLoaded
        ? _c(
            "div",
            { staticClass: "contract-details__inner" },
            [
              _c(
                "md-card-header",
                { staticClass: "contract-details__header" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "contract-details__route-back-btn",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.emitCloseDetails()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("keyboard_arrow_left")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "md-title" }, [
                    _vm._v(_vm._s(_vm.i18n.cont_details()))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "md-card-content",
                [
                  _vm.isRequestContract && _vm.isPendingRequest
                    ? _c("detail-row", {
                        staticClass: "contract-details__status",
                        attrs: {
                          prop: _vm.i18n.lbl_status(),
                          value: "" + _vm.i18n.cont_pending_status(),
                          alignLeft: true,
                          colWidth: [15]
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "contract-details__counterparty-details" },
                    [
                      _c("h3", [_vm._v(_vm._s(_vm.i18n.cont_counterparty()))]),
                      _vm._v(" "),
                      _c("detail-row", {
                        attrs: {
                          prop: _vm.i18n.com_name(),
                          value: _vm.requestorInfo.kyc.company_name,
                          alignLeft: true,
                          colWidth: [15, 20]
                        }
                      }),
                      _vm._v(" "),
                      _c("detail-row", {
                        attrs: {
                          prop: _vm.i18n.com_website(),
                          value: _vm.requestorInfo.kyc.website,
                          alignLeft: true,
                          colWidth: [15, 20]
                        }
                      }),
                      _vm._v(" "),
                      _c("detail-row", {
                        attrs: {
                          prop: _vm.i18n.com_email(),
                          value: _vm.requestorInfo.email,
                          alignLeft: true,
                          colWidth: [15, 20]
                        }
                      }),
                      _vm._v(" "),
                      _c("detail-row", {
                        attrs: {
                          prop: _vm.i18n.cont_company_id(),
                          value: _vm.requestorInfo.id,
                          copiable: true,
                          alignLeft: true,
                          colWidth: [15]
                        }
                      }),
                      _vm._v(" "),
                      _c("detail-row", {
                        attrs: {
                          prop: _vm.i18n.cont_contract_number(),
                          value: _vm.contract.contract_number,
                          copiable: true,
                          alignLeft: true,
                          colWidth: [15]
                        }
                      }),
                      _vm._v(" "),
                      _c("detail-row", {
                        attrs: {
                          prop: _vm.i18n.lbl_start_date(),
                          value: "" + _vm.i18n.d(_vm.contract.start_time),
                          alignLeft: true,
                          colWidth: [15, 20]
                        }
                      }),
                      _vm._v(" "),
                      _c("detail-row", {
                        attrs: {
                          prop: _vm.i18n.lbl_end_date(),
                          value: "" + _vm.i18n.d(_vm.contract.end_time),
                          alignLeft: true,
                          colWidth: [15, 20]
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "contract-details__documents-details" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "contract-details__documents-details-row"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "contract-details__document-name" },
                            [
                              _c("h3", [
                                _vm._v(_vm._s(_vm.i18n.lbl_documents()))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "contract-details__document-submitter"
                            },
                            [
                              _c("h3", [
                                _vm._v(_vm._s(_vm.i18n.lbl_submitted_by()))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "contract-details__document-type" },
                            [_c("h3", [_vm._v(_vm._s(_vm.i18n.lbl_type()))])]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "contract-details__documents-view-btn"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "contract-details__documents-details-row"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "contract-details__document-name" },
                            [
                              _c(
                                "i",
                                {
                                  staticClass:
                                    "contract-details__document-icon material-icons"
                                },
                                [_vm._v("note")]
                              ),
                              _vm._v(" "),
                              _c("p", [_vm._v(_vm._s(_vm.contractFile.name))])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "contract-details__document-submitter"
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.requestorInfo.kyc.company_name)
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "contract-details__document-type" },
                            [_c("p", [_vm._v(_vm._s(_vm.contractFile.type))])]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "contract-details__documents-view-btn"
                            },
                            [
                              _c(
                                "a",
                                {
                                  attrs: { href: _vm.getUrl, target: "_blank" }
                                },
                                [_vm._v(_vm._s(_vm.i18n.lbl_open()))]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("detail-row", {
                        attrs: {
                          prop: _vm.i18n.lbl_note(),
                          value: _vm.contract.note,
                          alignLeft: true,
                          colWidth: [15, 85]
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.request.request_state ===
                  _vm.REQUEST_STATES_STR.permanentlyRejected
                    ? _c(
                        "div",
                        { staticClass: "contract-details__reject-details" },
                        [
                          _c(
                            "h3",
                            {
                              staticClass:
                                "contract-details__reject-details-title"
                            },
                            [_vm._v(_vm._s(_vm.i18n.lbl_reject_reason()))]
                          ),
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.request.reject_reason) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-card-actions",
                { staticClass: "contract-details__btn-wrapper" },
                [
                  _vm.isRequestContract && !_vm.isRequestor
                    ? _c(
                        "md-button",
                        {
                          staticClass: "contract-details__btn md-primary",
                          attrs: {
                            disabled: _vm.isPending || !_vm.isPendingRequest
                          },
                          on: {
                            click: function($event) {
                              _vm.isRejectingRequest = true
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.i18n.lbl_reject()) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isRequestContract && !_vm.isRequestor
                    ? _c(
                        "md-button",
                        {
                          staticClass: "contract-details__btn md-primary",
                          attrs: {
                            disabled: _vm.isPending || !_vm.isPendingRequest
                          },
                          on: { click: _vm.signContract }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.i18n.cont_sign()) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isRequestContract &&
                  !_vm.isContractCompleted &&
                  _vm.request.invoices
                    ? _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          attrs: {
                            disabled:
                              _vm.isPending ||
                              !!_vm.request.dispute ||
                              !_vm.hasConfirmedInvoices
                          },
                          on: {
                            click: function($event) {
                              _vm.isStartingDispute = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.i18n.cont_start_a_dispute()))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isRequestContract && _vm.request.invoices
                    ? _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          attrs: {
                            disabled:
                              _vm.isPending ||
                              (!_vm.isRequestor && _vm.isConfirmedByCustomer) ||
                              (_vm.isConfirmedByContractor &&
                                _vm.isRequestor) ||
                              !_vm.hasConfirmedInvoices
                          },
                          on: { click: _vm.confirmCompleted }
                        },
                        [_vm._v(_vm._s(_vm.i18n.cont_confirm_completed()))]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isRequestContract && _vm.isLoaded
        ? _c("contracts-invoice", {
            attrs: {
              contractId: _vm.id,
              customerId: _vm.customerId,
              requestorId: _vm.requestorInfo.id,
              contractCompleted: _vm.isContractCompleted
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.request && _vm.request.dispute
        ? _c("contract-dispute", {
            attrs: {
              contractId: _vm.id,
              notes: _vm.request.notes,
              dispute: _vm.request.dispute,
              escrow: _vm.request.escrow
            },
            on: { "load-contract": _vm.loadContract }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isRejectingRequest
        ? _c(
            "modal",
            {
              attrs: { maxWidth: "800px" },
              on: {
                "close-request": function($event) {
                  _vm.isRejectingRequest = false
                }
              }
            },
            [
              _c("reject-form", {
                on: {
                  "submit-reject-message": _vm.rejectContract,
                  "close-request": function($event) {
                    _vm.isRejectingRequest = false
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isStartingDispute
        ? _c(
            "modal",
            {
              attrs: { maxWidth: "1200px" },
              on: {
                "close-request": function($event) {
                  _vm.isStartingDispute = false
                }
              }
            },
            [
              _c("start-dispute", {
                attrs: { contractId: _vm.request.id },
                on: { "close-request": _vm.closeDisputeForm }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-90419dec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90419dec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/contracts/index/Contracts.Details.vue
// module id = EPPA
// module chunks = 1